import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MediaObserver } from '@angular/flex-layout';
import { Overlay } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';

import {
  EecImageModalComponent
} from '~app/shared/modules/energy-label/components/eec-image-modal/eec-image-modal.component';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { NUMBER_404 } from '~shared/constants';

const WINDOW_OPEN_CONFIG = 'noopener,noreferrer';

const dialogBaseOptions = {
  width: '100%',
  backdropClass: 'freight-forwarding',
  panelClass: 'freight-forwarding__container'
};

@Injectable({
  providedIn: 'root'
})
export class EecModalService {
  constructor(
    private http: HttpClient,
    private mediaObserver: MediaObserver,
    private overlay: Overlay,
    private dialog: MatDialog,){
  }

  openEecDocument(url: string, title?:string): void {

    this.http.get(url,{
      responseType: 'blob'}
    ).subscribe(response => {
        if (response.type === 'application/pdf') {
          window.open(url, '_blank', WINDOW_OPEN_CONFIG);
        } else {
          this.openPopUp(url, title);
        }
      }, (error: any) => {
      if (error?.sourceError?.status !== NUMBER_404) {
        // Workaround to avoid CORS Error;
        window.open(url, '_blank', WINDOW_OPEN_CONFIG);
      }
    });
  }

  private openPopUp(url: string, title?:string) {
    const isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
    const isTablet = this.mediaObserver.isActive(MEDIA_ALISES.tablet)
      || this.mediaObserver.isActive(MEDIA_ALISES.tabletLandscape);

    const dialogMobileOptions = {
      ...dialogBaseOptions,
      maxWidth: '100%',
    };

    const dialogTabletOptions = {
      ...dialogBaseOptions,
      maxWidth: '579px',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
    };

    const dialogDesktopOptions = {
      ...dialogBaseOptions,
      maxWidth: '740px',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
    };

    const options = isMobile
      ? dialogMobileOptions
      : (isTablet ? dialogTabletOptions : dialogDesktopOptions);

    this.dialog.open(EecImageModalComponent, {
      ...options,
      data: {
        src: url,
        title
      }
    });
  }
}
